import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Drawer, Card, Form, notification, Col, Row } from 'antd'
import { DefaultTablePagination } from '../../components/_utils/appUtils'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { addHeadTypeFxn, listAllHeadTypeFxn } from './actions'
import { TableComp } from 'sz-react-utils-lite'

const AddHeadCategory = (props) => {
  const { getFieldDecorator } = props.form
  const { onClose, visible } = props
  let dispatch = useDispatch()
  let tableRef = useRef()
  const [total, setTotal] = useState(0)

  const handleSubmit = (e) => {
    const { form } = props
    e.preventDefault()
    form.validateFields(async (err, valData) => {
      if (!err) {
        let x = await dispatch(addHeadTypeFxn(valData))
        if (!x.error) {
          tableRef.current.reload()
          props.form.setFieldsValue({
            type: ''
          })
        }
      } else {
        if (!valData.type) {
          notification.warning({ message: 'Please Enter Type' })
          return
        }
      }
    })
  }
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let obj = {
        sortField: '_id',
        sortOrder: 'descend',
        ...params
      }
      let { data } = await dispatch(listAllHeadTypeFxn({ ...obj }))
      setTotal(data.total)
      resolve(data)
    })
  }
  // Define inputTypes for the form
  const inputTypes = {
    fields: [
      {
        key: 'type',
        label: 'Type',
        required: true,
        placeholder: 'Enter Type',
        type: 'text',
        span: 12
      }
    ]
  }

  // Define columns for the table
  const columns = [
    {
      key: '_id',
      title: '#',
      dataIndex: '_id',
      width: 50,
      render: (item, record, index) => {
        return (
          <>
            {(index + 1)}
          </>
        )
      }
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type'
    }
  ]

  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  return (
    <Drawer
      visible={visible}
      title={'Add Head Type'}
      onClose={onClose}
      width={'30%'}>
      <div className={'card'}>
        <div className={'unizportal'}>
          <>
            <Form onSubmit={handleSubmit}>
              <Row gutter={24}>
                <Card shadow={false} padding={false}>

                  {inputTypes.fields.map((item, key) => {
                    return (
                      <Col span={item.span ? item.span : 8} md={item.span ? item.span : 8} sm={24} xs={24}
                           key={key}
                           className={'mb10'}>
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout} />
                      </Col>
                    )
                  })}
                </Card>
              </Row>

              <Button type={'primary'} htmlType='submit' className={'mt-4 ml-4'}>
                submit
              </Button>
            </Form>
          </>
          <div className={'mt-4'}>
            <div className='d-flex align-items-center mb-3 heading-form'>
              <h5 className={'w-100'}>Head Type List ({total})</h5>
              <div className='sort-box-table mark-btn alignRight w-50'>
              </div>
            </div>
            <Card shadow={false} padding={false}>
              <TableComp
                apiRequest={apiRequest}
                columns={columns}
                pagination={DefaultTablePagination()}
                ref={tableRef}
              />
            </Card>
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default Form.create()(AddHeadCategory)
